import React from 'react';
import PropTypes from 'prop-types';

import Placeholder from 'components/consumer/Placeholder';
import PDPAvailableInSizesListItem from './PDPAvailableInSizesListItem';

const PDPAvailableInSizesRowUI = ({
  dimensions,
  id,
  image,
  isActive,
  loading,
  name,
  price,
  urlKey,
  productsData = [],
}) => {
  if (loading) {
    return (
      <div>
        <Placeholder type="rect" loading style={{ height: 72 }} />
      </div>
    );
  }

  if (!id || !name) {
    return null;
  }

  return (
    <div>
      <PDPAvailableInSizesListItem
        {...{
          id,
          name,
          price,
          dimensions,
          image,
          isActive,
          urlKey,
          productsData,
        }}
      />
    </div>
  );
};

PDPAvailableInSizesRowUI.propTypes = {
  dimensions: PropTypes.string,
  id: PropTypes.number,
  image: PropTypes.string,
  isActive: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  price: PropTypes.number,
  productsData: PropTypes.arrayOf(PropTypes.object),
  urlKey: PropTypes.string,
};

export default PDPAvailableInSizesRowUI;
